if ($('.filter-section').length) {
    $(document).ready(function () {
        mhFilter();
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            mhFilter();
        });
        document.addEventListener('ShoptetDOMPageContentLoaded', function () {
            mhFilter();
        });
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
            mhFilter();
        });

    })

}

function mhFilter() {

    $('.pagination__list .pagination__link--next').closest("li").addClass('nextPage');
    $('.pagination__list .pagination__link--prev').closest("li").addClass('prevPage');

    if (!$('.filter-section-boolean .param-filter-top>h4').length) {
        $('.filter-section-boolean .param-filter-top').addClass('filter-section').prepend('<h4><span>' + "Dostupnost" + '</span></h4>').prependTo('#category-filter-hover')
    }
    $('html').on('click', '#filters .filter-section h4', function () {
        $(this).closest('.filter-section').toggleClass('openIt')
    })
    $('.slider-wrapper').addClass('filter-section')
    $('.filter-section').addClass('openIt')
    var otherElements = $('.filter-section').not(openFilters);
    otherElements.removeClass('openIt');

    $('.filter-section').each(function () {
        if ($(this).find('.filter-label.active').length) {
            $(this).addClass('openIt')
        }
    })


    $('.category-top').after($('#category-header'));
    $('#category-header .listItemsTotal')
        .contents()
        .filter(function () {
            return this.nodeType === 3 && this.nodeValue.trim().length;
        })
        .first()
        .replaceWith(' ' + translation('polozekCelkem'));

    if (!$('#category-header .sortBtn').length) {
        $('#category-header').append('<button class="sortBtn">' + translation('seraditDle') + '</button>');
        $('.sortBtn').on('click', function () {
            $('#category-header').toggleClass('open');
            //    $('#category-header .sortBtn').text();
        })
    }
    if (!$('#category-header .spanFilter').length) {
        $('#category-header').prepend('<span class="spanFilter">' + translation('filtrovani') + '</span>');
    }



    if (!$('#content> .category__secondDescription').length) {
        $('#content').append($('.category__secondDescription'));
        $('.prednosti .slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: true,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
                { breakpoint: 479, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ]
        });
        $('.slick-slider').each(function () {

            var $wrapper = $('<div class="arrowWrapper"></div>');
            ($(this)).find('.slick-dots').after($wrapper);

            var $arrows = $(this).find('.slick-arrow');


            if ($arrows.length) {
                $arrows.each(function () {
                    var $arrow = $(this);

                    $arrow.appendTo($wrapper);
                });
            }
        });
        $('.prednosti .inner').first().addClass('active');
        $('.prednosti ul li').first().addClass('active');

        $('.prednosti ul li').on('click', function () {

            var target = $(this).data('target');


            $('.prednosti ul li').removeClass('active');
            $(this).addClass('active');


            $('.prednosti .inner').removeClass('active');
            $('#' + target).addClass('active');
        });
    }
}